'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _linksoftAlbatros = require('linksoft-albatros');

var _common = require('../../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddByEanCells = function (_Component) {
    (0, _inherits3.default)(AddByEanCells, _Component);

    function AddByEanCells(props) {
        (0, _classCallCheck3.default)(this, AddByEanCells);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddByEanCells.__proto__ || (0, _getPrototypeOf2.default)(AddByEanCells)).call(this, props));

        _this.eanChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            if (e.target.value.length < 20) {
                _this.setState({ ean: e.target.value });
            }
        };

        _this.amountChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            var value = parseInt(e.target.value, 10);
            if (isNaN(value)) _this.setState({ amount: '' });else if (value >= 0 && value <= _this.props.maxAmountPerItem) {
                _this.setState({ amount: e.target.value });
            }
        };

        _this.submit = function (e) {
            var _this$state = _this.state,
                amount = _this$state.amount,
                ean = _this$state.ean;

            if (!amount) amount = 1;
            _this.props.submitChanges({ amount: amount, ean: ean });
            _this.setState({ amount: '', ean: '' });

            var missingCartInput = document.querySelector('.cart-missing input[data-ean=\'' + ean + '\']');
            if (missingCartInput) {
                _common2.default.hideItemPlaceHolderByClass(missingCartInput, missingCartInput.dataset.productId);
            }

            var emptyCartButton = document.getElementById('emptyCartButton');
            if (emptyCartButton) {
                emptyCartButton.className = 'btn btn-grey';
            }
        };

        _this.state = { ean: '', amount: '' };
        return _this;
    }

    (0, _createClass3.default)(AddByEanCells, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                _state$ean = _state.ean,
                ean = _state$ean === undefined ? '' : _state$ean,
                _state$amount = _state.amount,
                amount = _state$amount === undefined ? '' : _state$amount;

            return _react2.default.createElement(
                'td',
                { colSpan: '7' },
                _react2.default.createElement(
                    'div',
                    { className: 'ean-add-wrap' },
                    _react2.default.createElement(
                        'div',
                        { className: 'add-by-ean__wrap' },
                        _react2.default.createElement(
                            'label',
                            { className: 'cart-ean-input-label', htmlFor: 'cart-ean-input' },
                            (0, _localize2.default)("App:AddItemByEAN"),
                            ':'
                        ),
                        _react2.default.createElement('input', { ref: 'eam', id: 'cart-ean-input', className: 'cart-ean-input', value: ean || '',
                            onChange: this.eanChange, type: 'text', placeholder: (0, _localize2.default)("App:Ean") }),
                        _react2.default.createElement(
                            'label',
                            { className: 'cart-ean-input-label', htmlFor: 'cart-ean-input-amount' },
                            (0, _localize2.default)("Common:Count"),
                            ':'
                        ),
                        _react2.default.createElement('input', { className: 'cart-ean-input-amnout quanitySniper', id: 'cart-ean-input-amount', ref: 'amount', type: 'text', value: amount || '',
                            onChange: this.amountChange, name: 'quanitySniper' }),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-green btn-add', onClick: this.submit },
                            _react2.default.createElement('i', { className: 'fa fa-plus' }),
                            '\xA0\xA0',
                            (0, _localize2.default)("Common:Add")
                        )
                    )
                )
            );
        }
    }]);
    return AddByEanCells;
}(_react.Component);

AddByEanCells.propTypes = {
    maxAmountPerItem: _propTypes2.default.number.isRequired,
    submitChanges: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
    return {
        maxAmountPerItem: state.cart.maxAmountPerItem
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    submitChanges: _actions2.default.submitChanges
    //addByEan: actions.addByEan
})(AddByEanCells);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/AddByEanCells.js
// module id = 900
// module chunks = 0